export default {
	weldMode: {
		selectFacesPrompt: "Sélectionnez les faces à souder.",
		weldlineLabel: "Cordon de soudure",
		selectFacePrompt: "Choisir une face...",
		selectMoreFacesPrompt: "Sélectionner d'autres faces ou appliquer...",
		helpLink: "Aide",
		applyButtonTitle: "Créer les cordons de soudure sélectionnés.",
		applyButton: "Appliquer",
		maxDistanceFallback: "la distance maximale autorisée entre les matériaux",
		someWeldsFailedMessage:
			"L'algorithme ne trouve pas de possibilité de créer un cordon de soudure entre certaines faces. " +
			"Veillez à ce que la distance entre les faces ne dépasse pas {distance} et que les arêtes soient parallèles.",
		errorListIntro: "Les différents messages d'erreur sont listés ci-dessous :",
		someWeldsFailedTitle: "Certains cordons de soudure n'ont pas pu être définis.",
		weldDefinitionFailedTitle: "Le cordon de soudure ne peut pas être défini.",
	},
	weldlines: {
		existingWeldlinesTitle: "Cordons de soudure existants",
		cleanAllCheckboxLabel: "Ébavurer tous les cordons de soudure",
		weldlineLabel: "Cordon de soudure",
		fillerLabel: "à remplir",
		pluggedLabel: "en bouchon",
		withCornersLabel: "avec",
		cornerLabel: "Coin",
		cornerTooltipChoose: "Veuillez indiquer si ce coin doit être soudé ou non.",
		cornerTooltipTooLarge: "Ce coin est trop grand pour être soudé. Veuillez consulter notre",
		cornerTooltipConstructionLink: "recommandation de conception.",
		defineSegmentsTitle: "Définir le motif",
		deleteWeldlineTitle: "Supprimer le cordon de soudure",
		segmentDialogTitle: "Diviser le cordon de soudure en segments.",
		segmentDialogInfo1:
			"Le cordon de soudure peut être soudé sur toute sa longueur. Cela permet d'obtenir une résistance élevée, " +
			"mais entraîne aussi un fort apport de chaleur et donc un risque de déformation de la pièce.",
		segmentDialogInfo2:
			"En divisant le cordon de soudure en segments courts, vous pouvez limiter cet effet.",
		numberOfSegmentsLabel: "Nombre de segments :",
		segmentLengthLabel: "Longueur d'un segment [mm] :",
		singleSegmentInfo:
			"Si un seul segment est défini, sa longueur est automatiquement égale à celle du cordon de soudure.",
		applyButton: "Valider",
		cancelButton: "Annuler",
		errorSegmentsMustBeInteger: "Le nombre de segments doit être un nombre entier.",
		errorSegmentsMinOne: "Le nombre de segments doit être d'au moins 1.",
		errorSegmentMinLength: "Un segment doit mesurer au moins 5 mm de long.",
		errorSegmentsTotalTooLong:
			"La longueur totale des segments dépasse celle du cordon de soudure. " +
			"Notez également qu'un espace d'au moins 5 mm doit rester entre les segments.",
	},
	rollDirectionMode: {
		noDirectionDefined:
			"Aucun sens de laminage n'est encore défini. Sélectionnez une arête extérieure pour le sens de laminage.",
		adjustHint:
			"Vous pouvez définir le tracé du sens de laminage en modifiant l'angle ou en cliquant sur une autre arête extérieure.",
		angleRangeLabel: "(0° à 180°)",
	},
	measuringMode: {
		selectPrompt: "Sélectionnez des faces ou des arêtes pour effectuer une mesure.",
	},
};
